import { render, staticRenderFns } from "./Vaff.vue?vue&type=template&id=90fb3ba8&"
import script from "./Vaff.vue?vue&type=script&lang=js&"
export * from "./Vaff.vue?vue&type=script&lang=js&"
import style0 from "./Vaff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports